import Layout from "../../../../src/components/Layout";
import Map from "../../../../src/images/2020_clean_water_act_violations_districts.webp";
import { Link } from 'gatsby';
import * as React from 'react';
export default {
  Layout,
  Map,
  Link,
  React
};